import React, { useEffect, useRef } from "react";
import { func } from "prop-types";
import { Formik, Form, Field } from "formik";
import { Row, Col, Collapse } from "reactstrap";

import { useSelector, useDispatch } from "react-redux";
import { Select, FieldSpy } from "../../../../components/formik";
import { optionsType } from "../../../../prop-types";
import {
  getFiltersWatchListEntriesByWatchList,
  watchListAllEntriesExportIsLoadingSelector,
  watchListEntriesByWatchListIsLoadingSelector,
  watchListEntriesExportIsLoadingSelector,
} from "../../selectors";
import { ButtonWithSpinner } from "../../../../components/common";
import {
  exportWatchListEntriesCsv,
  exportWatchListAllEntriesCsv,
  setWatchListEntryByWatchListSearchFilters,
} from "../../actions";
import Clickable from "../../../../components/common/Clickable";
import { CollapseButton, CollapseOpenIcon } from "../../../../assets";
import "./searchWatchListEntriesByWatchListForm.css";
import { FiUpload } from "react-icons/fi";
import { FaTimes } from "react-icons/fa";
import ButtonExport from "../../../../components/common/ButtonExport/ButtonExport";
import useRoles from "../../../../components/hooks/useRoles";

const SearchWatchListEntriesByWatchListForm = ({
  handleSubmit,
  watchLists,
  isOpenCollapse,
  toggleCollapse,
  watchListEntries,
}) => {
  const { watchListId } = useSelector(getFiltersWatchListEntriesByWatchList);
  const dispatch = useDispatch();
  const formikRef = useRef(null);
  const isLoading = useSelector(watchListEntriesByWatchListIsLoadingSelector);
  const isExportLoading = useSelector(watchListEntriesExportIsLoadingSelector);
  const { isClient, isCustomerSupport, isMaster } = useRoles();
  useEffect(() => {
    if (watchListId) {
      formikRef.current.setValues({ watchListId });
    }
  }, [watchListId]);

  const isExportAllLoading = useSelector(
    watchListAllEntriesExportIsLoadingSelector,
  );

  const handleTypeOfCheckChange = (watchListIdValue) => {
    dispatch(
      setWatchListEntryByWatchListSearchFilters({
        watchListId: watchListIdValue,
      }),
    );
  };

  const handleExport = (data) => {
    dispatch(exportWatchListEntriesCsv(data));
  };

  const handleExportAll = (type) => {
    dispatch(exportWatchListAllEntriesCsv({ exportType: type }));
  };

  const clearFilter = () => {
    dispatch(setWatchListEntryByWatchListSearchFilters({ watchListId: null }));

    formikRef.current.setValues({
      watchListId: null,
    });
  };

  const getWatchListLabel = (id) => {
    if (id) {
      const currentWatchList = watchLists.find(
        (wl) => Number(wl.value) === Number(watchListId),
      );
      if (currentWatchList) {
        return currentWatchList.label;
      }
      return undefined;
    }
  };

  return (
    <Formik
      ref={formikRef}
      onSubmit={handleSubmit}
      initialValues={{ watchListId: null }}
    >
      {(props) => {
        const { values } = props;

        return (
          <div>
            <div className="search-watch-list-by-watch-list-collapse-search">
              <Collapse isOpen={isOpenCollapse}>
                <Form className="search-watch-list-by-watch-list-search">
                  <Row className="search-watch-list-by-watch-list-inner-container">
                    <Col lg={4} className="p-0 ">
                      <Row className="justify-content-center ">
                        <Col style={{ maxWidth: 400 }} lg={9} className="p-0">
                          <Field
                            isClearable
                            type="text"
                            name="watchListId"
                            placeholder="Watchlist"
                            className="dropdown-group"
                            value={watchListId}
                            component={Select}
                            options={watchLists}
                          />
                          <FieldSpy
                            name="watchListId"
                            onChange={handleTypeOfCheckChange}
                          />
                        </Col>
                        <Col lg={3} className="pr-0">
                          <ButtonWithSpinner
                            text="Search"
                            outline
                            forced={!values.watchListId}
                            type="submit"
                            className="search-button-watch-list"
                            loading={isLoading}
                          />
                        </Col>
                      </Row>
                    </Col>

                    <Col lg={4} className="p-0">
                      <Row>
                        <Col
                          lg={12}
                          className="d-flex justify-content-end pr-0"
                        >
                          <div>
                            <ButtonExport
                              icon={<FiUpload size={20} />}
                              text="Export All"
                              type="button"
                              onClick={() => handleExportAll()}
                              loading={isExportAllLoading}
                              disabled={isClient}
                            />
                          </div>

                          <div className="ml-2">
                            <ButtonWithSpinner
                              text="Provenir"
                              className="provenir-button-watchlist"
                              outline
                              disabled={isClient || isCustomerSupport}
                              type="button"
                              onClick={() => handleExportAll("PROVENIR")}
                              loading={isExportAllLoading}
                            />
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Form>
                <div className="search-watch-list-by-watch-list-collapse-button">
                  {watchListEntries.length ? (
                    <Clickable onClick={toggleCollapse}>
                      <CollapseButton />
                    </Clickable>
                  ) : null}
                </div>
              </Collapse>
            </div>

            <div
              style={{ zIndex: 1 }}
              className="search-watch-list-by-watch-list-collapse-button"
            >
              <Clickable onClick={toggleCollapse}>
                {!isOpenCollapse ? <CollapseOpenIcon /> : null}
              </Clickable>
            </div>
            <div className="search-watch-list-by-watch-list-filters-main-container pr-4">
              <Row>
                <Col className="d-flex align-items-center " lg={6}>
                  <div className="single-filter-box">
                    {watchListId ? (
                      <div className="filters-menu-label">Search: </div>
                    ) : null}
                    {watchListId ? (
                      <div className="single-filter-chip">
                        {getWatchListLabel(watchListId)}
                        <FaTimes
                          className="remove-filter-icon"
                          onClick={clearFilter}
                          color="#707070"
                        />
                      </div>
                    ) : null}
                  </div>
                </Col>
                <Col lg={6} className="pr-0">
                  <div className="search-watch-list-by-watch-list-filters-actions">
                  {(isMaster || isCustomerSupport) && (<div>
                      <ButtonExport
                        text="Compatible Export"
                        icon={<FiUpload size={20} />}
                        type="button"
                        forced={watchListId === null}
                        onClick={() =>
                          handleExport({
                            watchListId,
                            isCompatibleExport: true,
                          })
                        }
                        loading={isExportLoading}
                      />
                    </div>)}
                    
                    <div>
                      <ButtonExport
                        text="Export"
                        icon={<FiUpload size={20} />}
                        type="button"
                        forced={watchListId === null}
                        onClick={() => handleExport({ watchListId })}
                        loading={isExportLoading}
                        disabled={isClient}
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        );
      }}
    </Formik>
  );
};

SearchWatchListEntriesByWatchListForm.propTypes = {
  handleSubmit: func.isRequired,
  watchLists: optionsType.isRequired,
};

export default SearchWatchListEntriesByWatchListForm;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/components/search-watch-list-entries-by-watch-list-form/SearchWatchListEntriesByWatchListForm.jsx